import { Component, HostListener, Input, OnChanges, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EdpEMgmMailModalComponent } from "@edp-components/edp-e-mgm-mail-modal/edp-e-mgm-mail-modal.component";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";
import { environment } from "@edp-environments/environment";
import { AppService } from "@edp-services/app.service";
import { EnvService } from "@edp-services/env.service";
import { SendShareSocial } from "@edp-store/actions/edpe.actions";
import { IAppState } from "@edp-store/state/app.state";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "edp-e-share-buttons-mgm",
    templateUrl: "./edp-e-share-buttons-mgm.component.html",
    styleUrls: ["./edp-e-share-buttons-mgm.component.scss"],
})
export class EdpEShareButtonsMgmComponent implements OnInit, OnChanges {
    @Input() codeToShare: string;

    public isApp: boolean;
    public openIcons = false;
    public mobileSize: boolean;
    public urlToShare: string;

    constructor(
        private readonly appService: AppService,
        private router: Router,
        public edpModalService: EdpModalService,
        private store: Store<IAppState>,
        private readonly translate: TranslateService,
        private envService: EnvService,
    ) {}

    ngOnInit(): void {
        this.isApp = environment.isApp;
        this.onResize();
    }

    public ngOnChanges() {
        if (this.codeToShare) {
            this.urlToShare = this.envService.appUrl() + "/share?type=MGM&code=" + this.codeToShare;
        }
    }

    public share(type: string): void {
        if (type === "email") {
            const modalOptions: NgbModalOptions = {
                windowClass: "edp-modal-window",
                backdrop: "static",
            };

            this.edpModalService.custom(EdpEMgmMailModalComponent, modalOptions, {} as IModalData).then(() => {});
        } else {
            this.store.dispatch(new SendShareSocial({ type }));
        }
    }

    public shareApp(type: string): void {
        this.store.dispatch(new SendShareSocial({ type }));
        if (type !== "messenger") {
            const appUrl = this.envService.appUrl() + "/share?type=MGM&code=" + this.codeToShare + "&socialMideaType=" + type;
            this.appService.socialShare(appUrl, type);
        } else {
            const message = this.translate.instant("pt.edp.edponline.dashboard.mgm-share.messenger", { code: this.codeToShare });
            const messengerUrl = this.envService.appUrl() + "/planeta-zero/inicio";
            this.appService.socialShare(messengerUrl, type, message);
        }
    }

    public toggle(): void {
        if (!this.mobileSize) {
            return;
        }
        this.openIcons = !this.openIcons;
    }

    @HostListener("window:resize")
    public onResize() {
        this.mobileSize = window.innerWidth < SCREEN_SIZES.WDGT;
        this.openIcons = !this.mobileSize;
    }
}
